import update from 'immutability-helper';
import { createReducer } from '../modules/helpers';
import { ActionTypes } from '../constants/index';

const initState = {
  domains: [], // stage :  dns -> check-dns -> ssl -> done
  status: 'init', // init -> loading -> loaded -> refreshing -> loaded
};

const emptyDomain = {
  urlsafe: '',
  url: '',
  stage: '',
  status: 'loading', // loading -> loaded -
};

export const domainReducer = createReducer(initState, {

  [ActionTypes.DOMAIN_GET_REQUEST](state) {
    return update(state, {
      domains: { $set: [] },
      status: { $set: 'loading' },
    });
  },
  [ActionTypes.DOMAIN_GET_SUCCESS](state, { payload }) {
    return update(state, {
      domains: { $set: payload.domains },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.DOMAIN_GET_FAILURE](state) {
    return update(state, {
      domains: { $set: [] },
      status: { $set: 'loaded' },
    });
  },

  [ActionTypes.DOMAIN_REFRESH_ALL_REQUEST](state) {
    return update(state, {
      status: { $set: 'refreshing' },
    });
  },
  [ActionTypes.DOMAIN_REFRESH_ALL_SUCCESS](state, { payload }) {
    return update(state, {
      domains: { $set: payload.domains },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.DOMAIN_REFRESH_ALL_FAILURE](state) {
    return update(state, {
      domains: { $set: [] },
      status: { $set: 'loaded' },
    });
  },

  [ActionTypes.DOMAIN_ADD_REQUEST](state) {
    const prevAddStillPending =
      (state.domains.length > 0)
      && ('status' in state.domains[0])
      && (state.domains[0].status === 'loading');

    if (prevAddStillPending) {
      return state;
    }

    return update(state, {
      domains: { $unshift: [emptyDomain] },
    });
  },

  [ActionTypes.DOMAIN_ADD_SUCCESS](state, { payload }) {
    return update(state, {
      domains: {
        0: { $set: payload },
      },
    });
  },

  [ActionTypes.DOMAIN_ADD_FAILURE](state) {
    // todo - add a check if domains[0] is loading
    return update(state, {
      domains: { $splice: [[0, 1]] },
    });
  },

  [ActionTypes.DOMAIN_DELETE_REQUEST](state, { payload }) {
    const { domainUrlsafe } = payload;
    const foundIndex = state.domains.findIndex(x => x.urlsafe === domainUrlsafe);

    return update(state, {
      domains: {
        [foundIndex]: {
          status: { $set: 'deleting' },
        },
      },
    });
  },
  [ActionTypes.DOMAIN_DELETE_SUCCESS](state, { payload }) {
    const { domainUrlsafe } = payload;
    const foundIndex = state.domains.findIndex(x => x.urlsafe === domainUrlsafe);
    // console.assert(foundIndex !== -1, 'Domain to be deleted is not accessible');

    return update(state, {
      domains: { $splice: [[foundIndex, 1]] },
    });
  },
  [ActionTypes.DOMAIN_DELETE_FAILURE](state, { payload }) {
    const { domainUrlsafe } = payload;
    const foundIndex = state.domains.findIndex(x => x.urlsafe === domainUrlsafe);
    // console.assert(foundIndex !== -1, 'Domain to be deleted is not accessible');

    return update(state, {
      domains: {
        [foundIndex]: {
          status: { $set: 'idle' },
        },
      },
    });
  },

  [ActionTypes.DOMAIN_CHECK_REACHABILITY_REQUEST](state, { payload }) {
    const { domainUrlsafe } = payload;
    const foundIndex = state.domains.findIndex(x => x.urlsafe === domainUrlsafe);
    // console.assert(foundIndex !== -1, 'Domain to be checked for reachability is not accessible');

    return update(state, {
      domains: {
        [foundIndex]: {
          status: { $set: 'checking-reachability' }, // try chaning to trying-reachability for better user feedback
        },
      },
    });
  },
  [ActionTypes.DOMAIN_CHECK_REACHABILITY_SUCCESS](state, { payload }) {
    const foundIndex = state.domains.findIndex(x => x.urlsafe === payload.urlsafe);
    // console.assert(foundIndex !== -1, 'Domain to be checked for reachability is not accessible');
    return update(state, {
      domains: {
        [foundIndex]: { $set: payload },
      },
    });
  },
  [ActionTypes.DOMAIN_CHECK_REACHABILITY_FAILURE](state, { payload }) {
    const { domainUrlsafe } = payload.data;
    const foundIndex =  state.domains.findIndex(x => x.urlsafe === domainUrlsafe);

    return update(state, {
      domains: {
        [foundIndex]: {
          status: { $set: 'not-reachable' }, // try chaning to failed-reachability for better user feedback
        },
      },
    });
  },

  [ActionTypes.DOMAIN_REFRESH_REQUEST](state, { payload }) {
    const { domainUrlsafe } = payload;
    const foundIndex = state.domains.findIndex(x => x.urlsafe === domainUrlsafe);
    return update(state, {
      domains: {
        [foundIndex]: {
          status: { $set: 'loading' },
        },
      },
    });
  },

  [ActionTypes.DOMAIN_REFRESH_SUCCESS](state, { payload }) {
    const foundIndex = state.domains.findIndex(x => x.urlsafe === payload.urlsafe);
    return update(state, {
      domains: {
        [foundIndex]: { $set: payload },
      },
    });
  },
  [ActionTypes.DOMAIN_REFRESH_FAILURE](state, { payload }) {
    const { domainUrlsafe } = payload;
    const foundIndex =  state.domains.findIndex(x => x.urlsafe === domainUrlsafe);
    return update(state, {
      domains: {
        [foundIndex]: {
          status: { $set: 'idle' },
        },
      },
    });
  },
  // [ActionTypes.DOMAIN_SHOW_ADD_FORM](state) {
  //   return update(state, {
  //     showAddForm: { $set: true },
  //   });
  // },
  // [ActionTypes.DOMAIN_HIDE_ADD_FORM](state) {
  //   return update(state, {
  //     showAddForm: { $set: false },
  //   });
  // },
});



// WEBPACK FOOTER //
// ./scripts/reducers/domain.js